/**
 * Token sesije čuvamo u IndexedDB, ne u localStorage.
 * IndexedDB nije dostupan sinkrono skriptama trećih strana i lakše ga je
 * kasnije zamijeniti pravom autentikacijom.
 */
const DB_NAME = 'racunko'
const STORE = 'session'
const TOKEN_KEY = 'token'
const DEVICE_KEY = 'device_id'

function openDb(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, 1)
    request.onupgradeneeded = () => {
      if (!request.result.objectStoreNames.contains(STORE)) request.result.createObjectStore(STORE)
    }
    request.onsuccess = () => resolve(request.result)
    request.onerror = () => reject(request.error)
  })
}

async function read(key: string): Promise<string | null> {
  const db = await openDb()
  return new Promise((resolve, reject) => {
    const request = db.transaction(STORE, 'readonly').objectStore(STORE).get(key)
    request.onsuccess = () => resolve((request.result as string | undefined) ?? null)
    request.onerror = () => reject(request.error)
  })
}

async function write(key: string, value: string): Promise<void> {
  const db = await openDb()
  return new Promise((resolve, reject) => {
    const transaction = db.transaction(STORE, 'readwrite')
    transaction.objectStore(STORE).put(value, key)
    transaction.oncomplete = () => resolve()
    transaction.onerror = () => reject(transaction.error)
  })
}

export async function clearSession(): Promise<void> {
  const db = await openDb()
  await new Promise<void>((resolve, reject) => {
    const transaction = db.transaction(STORE, 'readwrite')
    transaction.objectStore(STORE).clear()
    transaction.oncomplete = () => resolve()
    transaction.onerror = () => reject(transaction.error)
  })
}

function randomDeviceId(): string {
  const bytes = new Uint8Array(16)
  crypto.getRandomValues(bytes)
  return `dev-${[...bytes].map((byte) => byte.toString(16).padStart(2, '0')).join('')}`
}

let cachedToken: string | null = null

export async function getDeviceId(): Promise<string> {
  const existing = await read(DEVICE_KEY)
  if (existing) return existing
  const created = randomDeviceId()
  await write(DEVICE_KEY, created)
  return created
}

export async function getToken(): Promise<string | null> {
  if (cachedToken) return cachedToken
  cachedToken = await read(TOKEN_KEY)
  return cachedToken
}

export async function setToken(token: string): Promise<void> {
  cachedToken = token
  await write(TOKEN_KEY, token)
}

export function resetTokenCache(): void {
  cachedToken = null
}
